/* unplugin-vue-components disabled */import { render } from "./manage.vue?vue&type=template&id=9e380172&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"

import "./manage.vue?vue&type=style&index=0&id=9e380172&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e380172"]])

export default __exports__